if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonLabel = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.originalLabelText = this.submitButtonLabel ? this.submitButtonLabel.textContent : '';
      this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.querySelector('.product-form__error-message');
      this.hideErrors = this.dataset.hideErrors === 'true';

      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.style.opacity = '1';
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Double-submit guard — ignore taps while an add is already in flight.
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.hideError();

      // Instant feedback — runs synchronously on tap, before the network request.
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.style.opacity = '0.7';
      if (this.submitButtonLabel) this.submitButtonLabel.textContent = 'Adding…';

      const formData = new FormData(this.form);
      formData.append('sections', 'cart-drawer');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then((res) => res.json())
        .then((data) => {
          // /cart/add.js only returns a status field when the add FAILED (e.g. sold out).
          if (data.status) {
            this.showError(data.description || data.message || 'Could not add to bag.');
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.renderContents(data);
        })
        .catch(() => {
          this.showError('Something went wrong. Please try again.');
        })
        .finally(() => {
          // Reset the button so it can be used again.
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.style.opacity = '1';
          if (this.submitButtonLabel) this.submitButtonLabel.textContent = this.originalLabelText;
        });
    }

    showError(message) {
      if (this.hideErrors) return;
      if (this.errorWrapper && this.errorMessage) {
        this.errorMessage.textContent = message;
        this.errorWrapper.removeAttribute('hidden');
      } else {
        console.error(message);
      }
    }

    hideError() {
      if (this.errorWrapper) this.errorWrapper.setAttribute('hidden', '');
    }
  });
}
